const formatDate = (data, displayDate = false, extended = false) => {
  if (data) {
    const date = new Date(data);

    if (extended) {
      const dateOptions = { month: "short", day: "numeric" };
      const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };

      const formatExtendedDate = date.toLocaleString(undefined, dateOptions);
      const formatExtendedTime = date.toLocaleString(undefined, timeOptions);

      return `${formatExtendedDate} | ${formatExtendedTime}`;
    } else {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const formattedDate = date.toLocaleString(undefined, options);

      if (displayDate) {
        return formattedDate;
      } else {
        const day = date.getUTCDate();
        const month = date.getUTCMonth() + 1;
        const year = date.getUTCFullYear();

        const formatMonth = month < 10 ? `0${month}` : month;
        const formatDay = day < 10 ? `0${day}` : day;

        return `${year}-${formatMonth}-${formatDay}`;
      }
    }
  } else {
    return null;
  }
};

const getMonthStartDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}-01`;
};

const getTodayDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const parseDateValue = (value) => {
  if (!value) return null;

  const dateOnly = String(value).split("T")[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
    const [year, month, day] = dateOnly.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  return new Date(value);
};

const formatCalendarDate = (value) => {
  if (!value) return "-";
  const date = parseDateValue(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString();
};

export {
  formatDate,
  getMonthStartDate,
  getTodayDate,
  parseDateValue,
  formatCalendarDate,
};
